import "./Styles.css";
import phone from "../../assets/phone.png";
import github from "../../assets/github.svg";
// import instagram from "../../assets/instagram.svg";
import linkedin from "../../assets/LinkedIn.svg";
import { Link } from "react-router-dom";

const LandingPage = () => {
  return (
    <body className="main_container">
      {/* Special Pricing Banner */}
      <div
        className="special-banner"
        style={{
          background:
            "linear-gradient(90deg, #A7C7E7 0%, #E0BBE4 50%, #F7CAC9 100%)",
          color: "#222",
          padding: "8px 0",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1rem",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        🚀 Special Pricing for MVPs & Prototypes — Get Your Idea Live Fast!
      </div>
      <header className="header">
        <nav className="header__menu">
          <Link className="header__menu__link" to="/">
            Home
          </Link>
          <Link className="header__menu__link" to="/projects">
            Projects
          </Link>
          <Link className="header__menu__link" to="/blogs">
            Blogs
          </Link>
          <div className="dropdown">
            <Link
              className="header__menu__link"
              to=""
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Explore
            </Link>
            <ul className="dropdown-menu">
              <Link className="dropdown-item" to="/ds">
                Data Structure
              </Link>
            </ul>
          </div>
        </nav>
      </header>
      <main className="presentation">
        <section className="presentation__content">
          <h1 className="presentation__content__title">
            We build the foundation for your digital success{" "}
            <strong className="title-highlighted">
              Crafting Your Mobile Dreams{" "}
            </strong>
          </h1>
          <p className="presentation__content__text">
            At Binarystack Labs, we specialize in crafting exceptional mobile
            experiences using React Native technology. Our team of skilled
            developers and designers is dedicated to building high-quality
            mobile applications that engage users and drive results. From
            concept to launch, we leverage the power of React Native, Node.js,
            MongoDB, PostgreSQL, OTP, and AWS S3 to create seamless and
            intuitive mobile solutions for businesses of all sizes. Partner with
            us to elevate your brand and make your mark in the digital world.
          </p>
          <p className="presentation__content__text">
            We also help startups and businesses rapidly create MVPs and
            prototypes, turning your ideas into functional products quickly and
            efficiently. Our agile approach ensures you can validate concepts
            and bring your vision to market with speed and confidence.
          </p>
          <div className="presentation__link">
            {/* Invite users to contact for questions */}
            <p className="presentation__content__text">
              Have any questions or want to discuss your project? Feel free to
              contact us! It's free!
            </p>
            <div className="presentation__contact">
              <h2 className="presentation__link__subtitle">Contact Us</h2>
              <p>
                Email:{" "}
                <a href="mailto:binarystack01@gmail.com">
                  binarystack01@gmail.com
                </a>
              </p>
              <p>
                Phone: <a href="tel:+15106897734">+1 (510) 689 7734</a>
              </p>
            </div>
            <h2 className="presentation__link__subtitle">Connect With Us</h2>
            <a
              className="presentation__link__url"
              href="https://github.com/jmejiamu"
            >
              <img
                className="presentation__link__url__img"
                src={github}
                alt="github-img"
              />
              Github
            </a>
            <a
              className="presentation__link__url"
              href="https://www.linkedin.com/company/binarystack-labs/about/"
            >
              <img
                className="presentation__link__url__img"
                src={linkedin}
                alt="linkedin-img"
              />
              Linkedin
            </a>
            {/* <a
              className="presentation__link__url"
              href="https://www.instagram.com/binarystack01"
            >
              <img
                className="presentation__link__url__img"
                src={instagram}
                alt="instagram-img"
              />
              Instagram
            </a> */}
            {/* Contact Information */}
          </div>
        </section>
        <img
          className="presentation__image"
          src={phone}
          alt="Binarystack-labs-phone"
        />
      </main>
      <footer className="footer">
        <p>Made by BinaryStack Labs &copy; 2025</p>
      </footer>
    </body>
  );
};

export default LandingPage;
